import { render, staticRenderFns } from "./detailModify.vue?vue&type=template&id=48653167"
import script from "./detailModify.vue?vue&type=script&lang=js"
export * from "./detailModify.vue?vue&type=script&lang=js"
import style0 from "./detailModify.vue?vue&type=style&index=0&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports